<template>
  <settings-modal class="currency-conversion-payment-cancel-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <p class="subheading red--text text-darken-2 mb-0">Are you sure you want to cancel currency conversion?</p>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CurrencyConversionPaymentCancelModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        convertCancelByAccountantApiRequest: new ApiRequest(PaymentApi.convertCancelByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      },
      heading () {
        return `Cancel payment ${this.payment.id}?`
      },
      loading () {
        return this.convertCancelByAccountantApiRequest.loading
      },
      error () {
        return this.convertCancelByAccountantApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.convertCancelByAccountantApiRequest
          .execute(this.payment.id)
          .then(this.convertCancelSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      convertCancelSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)

        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully canceled.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
  .currency-conversion-payment-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
